import React from "react";
import clx from "classnames";
import classes from "./Login.module.scss";

function Login() {
  return <div className={clx(classes.login, classes.bold)}>Login</div>;
}

export default Login;
